import { canViewOrgInsights } from "../../../utils/permissions";
import { AtsDataState, MetricName } from "../../graphql";
import useCurrentUser from "../../hooks/useCurrentUser";

/**
 * Gives a flat (not grouped) list of metrics the current user can view.
 */
const useEnabledMetrics = (
  atsEnabledMetrics: { metricName: MetricName; atsDataState: AtsDataState }[],
  ownDataRequest = false
): MetricName[] => {
  const currentUser = useCurrentUser();

  if (!currentUser) {
    return [];
  }

  if (!canViewOrgInsights(currentUser) && !ownDataRequest) {
    return [];
  }

  // TODO: we should refactor further
  // so that all information comes from the backend
  // useAtsDataState() should return
  // enabledReports { name, enabledMetrics, enabledDimensions, enabledFilters }
  // and then we should refactor this and related functions
  return atsEnabledMetrics
    .filter((metric) => metric.atsDataState === AtsDataState.DataAvailable)
    .map((metric) => metric.metricName);
};

export default useEnabledMetrics;
